import { useState } from "react";
import "../styles/Audit.scss";
import LoomEmbed from "../components/LoomEmbed";

const VIDEO_URL = "https://www.loom.com/embed/3ff2efa606f74002938a397e98cff3d2";

// Live Google Apps Script endpoint — leads land in Kevin's sheet, from which
// he adds them to the Mailmeteor email sequence by hand. Not a placeholder.
const FORM_ENDPOINT_URL =
    "https://script.google.com/macros/s/AKfycbzhpeTKYbsKIhynUHnXQG8nmWWJThFN4F3cKjqdZZKAajEENj7LhxRzP-HQpdL5iZlr/exec";

const AuditSignupForm = ({ idSuffix }) => {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("idle"); // idle | sending | success
    const [error, setError] = useState("");

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        const trimmed = email.trim();
        if (!trimmed) return;

        setError("");
        setStatus("sending");

        try {
            const res = await fetch(FORM_ENDPOINT_URL, {
                method: "POST",
                body: new URLSearchParams({ email: trimmed }),
            });
            const data = await res.json();
            if (data && data.success) {
                setStatus("success");
            } else {
                setStatus("idle");
                setError("Something went wrong — try again in a moment.");
            }
        } catch (e) {
            setStatus("idle");
            setError("Something went wrong — try again in a moment. Your email is still in the field above.");
        }
    };

    if (status === "success") {
        return (
            <div className="lead-card">
                <div className="lead-success">
                    <p><strong>Check your inbox.</strong> The first
                        email is on its way. If it isn't there in a few minutes, look in Promotions or
                        Spam and drag it across — that'll keep the rest of the week out of there too.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="lead-card">
            <form className="lead-form" onSubmit={handleSubmit}>
                <label className="sr-only" htmlFor={`audit-email-${idSuffix}`}>Your email</label>
                <input
                    id={`audit-email-${idSuffix}`}
                    name="email"
                    type="email"
                    required
                    placeholder="you@email.com"
                    className="lead-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <button type="submit" className="lead-submit" disabled={status === "sending"}>
                    <span>{status === "sending" ? "Sending…" : "Start My Audit"}</span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <polyline points="9 6 15 12 9 18" />
                    </svg>
                </button>
            </form>
            {error && <p className="lead-error" role="alert">{error}</p>}
        </div>
    );
};

const Audit = () => (
    <div className="lead-page">
        <main className="lead-main">
            <header className="lead-header">
                <h1 className="lead-h1">The 7-Day Podcast Audit</h1>
                <p className="lead-lede">
                    You've been guessing where to put your effort. Every day this week, you
                    check one part of your show, find out what good looks like, and fix it.
                </p>
            </header>

            <section className="lead-section">
                <LoomEmbed url={VIDEO_URL} title="The 7-Day Podcast Audit — walkthrough video" />
            </section>

            <section className="lead-section">
                <AuditSignupForm idSuffix="1" />
            </section>

            <hr className="lead-hr" />

            <section className="lead-section">
                <h2 className="lead-h2">What you'll have by day 7</h2>
                <ul className="lead-list lead-body">
                    <li><strong>A report on your show</strong> — timestamped, specific, showing where attention breaks</li>
                    <li><strong>A read on the things you're currently guessing at</strong>, measured against what's actually verifiable rather than the figures the industry repeats without sourcing</li>
                    <li><strong>Changes ready to go into your next episode</strong>, none taking more than half an hour</li>
                    <li><strong>Replies from your own listeners</strong>, to a question you put to them on day 7</li>
                </ul>
            </section>

            <section className="lead-section">
                <AuditSignupForm idSuffix="2" />
            </section>

            <hr className="lead-hr" />

            <section className="lead-section lead-body--center">
                <h2 className="lead-h2">Who it's for</h2>
                <div className="lead-body">
                    <p>
                        Podcasters with 20+ episodes who suspect their show should be doing more
                        for their business than it is.
                    </p>
                    <ul className="lead-list lead-list--narrow">
                        <li>Not for launches</li>
                        <li>Not for chart tactics</li>
                        <li>Not about growing downloads</li>
                    </ul>
                    <p>It's about getting more out of the audience you already have.</p>
                </div>
            </section>

            <section className="lead-body--center">
                <div className="lead-body" style={{ maxWidth: "28rem", margin: "0 auto", display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <img
                        src="/img/kevin.jpg"
                        alt="Kevin, founder of Podsy"
                        className="lead-avatar"
                    />
                    <p>
                        I'm Kevin, founder of Podsy. Our show got past 30,000 downloads and
                        produced crickets and tumbleweed — no leads, no revenue, barely a reply.
                    </p>
                    <p>
                        It took us a while to work out what was actually broken. After 350+
                        calls (and counting!) with podcasters, I realised the same things were
                        wrong on nearly every show.
                    </p>
                    <p>This audit is how you fix them on your show.</p>
                </div>
            </section>
        </main>
    </div>
);

export default Audit;
